export default __webpack_public_path__ + "static/step_09-facaf2f5cbad573348987b4e746776e7.png";